// List of Alpha-2 country codes to display in the drop down for phone number entry in our pre-built UI components.
//
// This list contains all allowed country codes, in alphabetical order, with the exception of the US, which is placed first as it is
// the default and our most common user country.
//
// This list was built by pulling all countries from https://www.iban.com/country-codes and then removing countries that are not on our
// unsupported countries (https://app.launchdarkly.com/default/production/features/default-banned-countries-for-phone-validation/targeting).
//
// Other useful links are the IBAN Alpha-2 code list (https://www.iban.com/country-codes) and Twilio's per-country notes
// (https://www.twilio.com/en-us/guidelines/ag/sms). Just substitute the country code in that URL!
//
// This list is served to any customer, regardless of whether they are on the default country allowlist (only US and Canada) or they allow
// all countries. This means that users may be able to choose a country that is not allowed for a customer and receive an error. This should
// be improved in the future: ODEVX-34.
const COUNTRIES_LIST = {
    US: '1',
    AX: '358',
    AS: '1684',
    AG: '1268',
    AI: '1264',
    AR: '54',
    AT: '43',
    AU: '61',
    BE: '32',
    BJ: '229',
    BO: '591',
    BR: '55',
    IO: '246',
    BN: '673',
    BG: '359',
    BF: '226',
    CM: '237',
    CA: '1',
    BQ: '599',
    CF: '236',
    CL: '56',
    CX: '61',
    CC: '61',
    CO: '57',
    CD: '243',
    CK: '682',
    CR: '506',
    HR: '385',
    CZ: '420',
    DK: '45',
    DO: '1829',
    EC: '593',
    SV: '503',
    EE: '372',
    SZ: '268',
    FK: '500',
    FI: '358',
    FR: '33',
    GF: '594',
    DE: '49',
    GH: '233',
    GR: '30',
    GD: '1473',
    GT: '502',
    GG: '44',
    GW: '245',
    GY: '592',
    HU: '36',
    IS: '354',
    IN: '91',
    IE: '353',
    IM: '44',
    IT: '39',
    JM: '1876',
    JP: '81',
    KZ: '7',
    KE: '254',
    KI: '686',
    KR: '82',
    LV: '371',
    LT: '370',
    LU: '352',
    MO: '853',
    MT: '356',
    MH: '692',
    MR: '222',
    MU: '230',
    YT: '262',
    MX: '52',
    MC: '377',
    ME: '382',
    NR: '674',
    NL: '31',
    NZ: '64',
    NI: '505',
    NF: '672',
    NO: '47',
    PA: '507',
    PY: '595',
    PE: '51',
    PN: '870',
    PL: '48',
    PT: '351',
    PR: '1',
    RO: '40',
    BL: '590',
    SH: '290',
    KN: '1869',
    LC: '1758',
    MF: '590',
    PM: '508',
    SM: '378',
    ST: '239',
    SC: '248',
    SX: '599',
    SK: '421',
    SI: '386',
    ZA: '27',
    SS: '211',
    ES: '34',
    SR: '597',
    SJ: '47',
    SE: '46',
    CH: '41',
    TW: '886',
    TZ: '255',
    TK: '690',
    TO: '676',
    TT: '1868',
    TR: '90',
    UA: '380',
    GB: '44',
    UM: '1',
    UY: '598',
    VA: '379',
    EH: '212'
};

export { COUNTRIES_LIST };
//# sourceMappingURL=country.mjs.map
